import React from "react";

interface FilterSelectProps {
  selectedOption: string;
  handleFilterChange: (value: string) => void;
}

const FilterSelect: React.FC<FilterSelectProps> = ({
  selectedOption,
  handleFilterChange,
}) => (
  <form onSubmit={(e) => e.preventDefault()}>
    <div className="export-select-area">
      <label htmlFor="options" className="export-select-label">
        Choose an option:
      </label>
      <select
        id="options"
        name="options"
        className="date-range-select"
        value={selectedOption}
        onChange={(e) => handleFilterChange(e.target.value)}
      >
        <option value="Today">Today</option>
        <option value="Yesterday">Yesterday</option>
        <option value="LastWeek">Last 7 days</option>
        <option value="LastMonth">Last 30 days</option>
        <option value="180days">Last 180 days</option>
        <option value="CustomizeDate">Customize date</option>
      </select>
    </div>
  </form>
);

export default FilterSelect;
